<template>
    <div class="breadcrumb-background" :class="bemAdd(facet)">
        <slot/>
    </div>
</template>

<script>
    import bemMixin from 'framework/mixins/bem';
    import { mapState } from 'vuex';

    export default {
        mixins: [bemMixin('breadcrumb-background')],
        computed: {
            ...mapState('breadcrumbs', ['facet']),
        },
    };
</script>
